import "regenerator-runtime/runtime";
import _asyncToGenerator from "C:/Users/ZKLZ/Desktop/\u9879\u76EE/\u6E1D\u9AD8\u6700\u65B0\u5F00\u53D1\u5730\u5740/\u6E1D\u9AD8\u53C2\u5EFA\u65B9\u7CFB\u7EDF\u7BA1\u7406\u7AEF/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.regexp.to-string";
import CryptoJS from 'crypto-js';
var privateKey = 'MIICdwIBADANBgkqhkiG9w0BAQEFAASCAmEwggJdAgEAAoGBAMFPa+v52FkSUXvcUnrGI/XzW3EpZRI0s9BCWJ3oNQmEYA5luWW5p8h0uadTIoTyYweFPdH4hveyxlwmS7oefvbIdiP+o+QIYW/R4Wjsb4Yl8MhR4PJqUE3RCy6IT9fM8ckG4kN9ECs6Ja8fQFc6/mSl5dJczzJO3k1rWMBhKJD/AgMBAAECgYEAucMakH9dWeryhrYoRHcXo4giPVJsH9ypVt4KzmOQY/7jV7KFQK3x//27UoHfUCak51sxFw9ek7UmTPM4HjikA9LkYeE7S381b4QRvFuf3L6IbMP3ywJnJ8pPr2l5SqQ00W+oKv+w/VmEsyUHr+k4Z+4ik+FheTkVWp566WbqFsECQQDjYaMcaKw3j2Zecl8T6eUe7fdaRMIzp/gcpPMfT/9rDzIQk+7ORvm1NI9AUmFv/FAlfpuAMrdL2n7p9uznWb7RAkEA2aP934kbXg5bdV0R313MrL+7WTK/qdcYxATUbMsMuWWQBoS5irrt80WCZbG48hpocJavLNjbtrjmUX3CuJBmzwJAOJg8uP10n/+ZQzjEYXh+BszEHDuw+pp8LuT/fnOy5zrJA0dO0RjpXijO3vuiNPVgHXT9z1LQPJkNrb5ACPVVgQJBALPeb4uV0bNrJDUb5RB4ghZnIxv18CcaqNIft7vuGCcFBAIPIRTBprR+RuVq+xHDt3sNXdsvom4h49+Hky1b0ksCQBBwUtVaqH6ztCtwUF1j2c/Zcrt5P/uN7IHAd44K0gIJc1+Csr3qPG+G2yoqRM8KVqLI8Z2ZYn9c+AvEE+L9OQY=';

/**
 * @description RSA加密
 * @param data
 * @returns {string}
 */
export function encrypt(word, keyStr) {
  keyStr = keyStr ? keyStr : 'cooperation@2020'; //判断是否存在ksy，不存在就用定义好的key
  var key = CryptoJS.enc.Utf8.parse(keyStr);
  var srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}
export function decrypt(word, keyStr) {
  keyStr = keyStr ? keyStr : 'cooperation@2020';
  var key = CryptoJS.enc.Utf8.parse(keyStr);
  // let pwd = CryptoJS.format.Hex.parse(word);
  var pwd = word;
  var decrypt = CryptoJS.AES.decrypt(pwd, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  console.log(CryptoJS.enc.Utf8.stringify(decrypt).toString());
  return CryptoJS.enc.Utf8.stringify(decrypt).toString();
}
export function encryptedData(_x) {
  return _encryptedData.apply(this, arguments);
}

/**
 * @description RSA解密
 * @param data
 * @returns {PromiseLike<ArrayBuffer>}
 */
function _encryptedData() {
  _encryptedData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _encryptedData.apply(this, arguments);
}
export function decryptedData(data) {
  var decrypt = new JSEncrypt();
  decrypt.setPrivateKey("-----BEGIN RSA PRIVATE KEY-----".concat(privateKey, "-----END RSA PRIVATE KEY-----"));
  data = decrypt.decrypt(JSON.stringify(data));
  return data;
}